const translation = {
  custom: 'Personalización',
  upgradeTip: {
    prefix: 'Actualiza tu plan para',
    suffix: 'personalizar tu marca.',
    des: 'Actualiza tu plan para personalizar tu marca',
    title: 'Actualiza tu plan',
  },
  webapp: {
    title: 'Personalizar marca de web app',
    removeBrand: 'Eliminar Powered by Dify',
    changeLogo: 'Cambiar Imagen de Marca Powered by',
    changeLogoTip: 'Formato SVG o PNG con un tamaño mínimo de 40x40px',
  },
  app: {
    title: 'Personalizar encabezado de la aplicación',
    changeLogoTip: 'Formato SVG o PNG con un tamaño mínimo de 80x80px',
  },
  upload: 'Subir',
  uploading: 'Subiendo',
  uploadedFail: 'Error al subir la imagen, por favor vuelve a intentar.',
  change: 'Cambiar',
  apply: 'Aplicar',
  restore: 'Restaurar valores predeterminados',
  customize: {
    contactUs: ' contáctanos ',
    prefix: 'Para personalizar el logotipo de la marca dentro de la aplicación, por favor',
    suffix: 'para actualizar a la edición Enterprise.',
  },
}

export default translation
